import ClientPortal from '../../../plugins/axios'

export default {
    // API Regions, Province, City
    regions() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/login/regions`, {},
            { withCredentials: true }
        )
    },
    provinces(region) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/provinces`, region,
            { withCredentials: true }
        )
    },
    cities(city) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/cities`, city,
            { withCredentials: true }
        )
    },

    // API all Hospitals/Clinics
    hospClin(hospitalCred) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/hospClin`,
            hospitalCred,
            { withCredentials: true }
        )
    },

    // API for Hospital and Clinic Dialogs
    hospClinDialog(hospClinData) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/hospClin/dialog`,
            hospClinData,
            { withCredentials: true }
        )
    },

    // API Specializations
    specializations() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/login/specializations`, {},
            { withCredentials: true }
        )
    },

    // API all Doctor's
    doctors(doctorCred) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/doctors`, doctorCred,
            { withCredentials: true }
        )
    },

    // API for Doctor Dialogs
    doctorsDialog(doctorCred) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/doctors/dialog`, doctorCred, 
            { withCredentials: true } 
        )
    }
}
